import { apiClient } from "@/lib/apiClient";

export async function fetchOneSchemaToken(): Promise<string> {
  const res = await apiClient.get<{ token: string }>("/oneschema/token");
  return res.data.token;
}
